import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Button, TextField } from '@mui/material';
import MaskedInput from 'react-text-mask';

import stringUtils from '../../../utils/StringUtils';

import './UpdateAgentForm.scss';

function UpdateAgentForm({ name, surname, phone, onSubmit }) {

  function validate(values) {
    const errors = {};
  
    if (!values.name) {
      errors.name = 'O nome é obrigatório';
    }
  
    if (!values.surname) {
      errors.surname = 'O sobrenome é obrigatório';
    }
  
    if (!values.phone) {
      errors.phone = 'Seu telefone é obrigatório';
    }

    if (!stringUtils.isValidPhone(values.phone)) {
      errors.phone = 'Telefone inválido';
    }
  
    return errors;
  }

  return (
    <Formik
      initialValues={{
        name: name,
        surname: surname,
        phone: phone
      }}
      validate={validate}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="form">
          <Field
            as={TextField}
            className="field"
            name="name"
            label="Nome"
            variant="outlined"
            fullWidth
          />
          <ErrorMessage name="name" component="div" />
          <Field
            as={TextField}
            className="field"
            name="surname"
            label="Sobrenome"
            variant="outlined"
            fullWidth
          />
          <ErrorMessage name="surname" component="div" />
          <Field
            as={MaskedInput}
            className="masked-field"
            name="phone"
            type="text"
            label="Telefone"
            variant="outlined"
            mask={stringUtils.getPhoneMask()}
            placeholder="(11) 1111-1111"
          />
          <ErrorMessage name="phone" component="div" />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="button"
            disabled={isSubmitting}
            fullWidth
          >
            {isSubmitting ? 'Enviando ...' : 'Atualizar'}
          </Button>
        </Form>
      )}
    </Formik>
  );
}

export default UpdateAgentForm;
